import PropTypes from 'prop-types';
import Checkbox from 'modules/common/components/Checkbox';
import Toggle from 'modules/common/components/Toggle';
import {
  ItemContainer,
  ItemDetails,
  ItemImage,
  ItemName,
  ItemDescription,
  RemoveItemIcon,
  ItemWrapper,
  BranchesList,
  BranchName,
} from './AddDoctorsModal.style';

const DoctorRecord = ({
  accountKey,
  image,
  name,
  specialtyName,
  branches,
  onChangeBranchSelection,
  onExclusiveChange,
  removeItem,
  topLevelEntityName,
  examinationRoomKey,
  isEmbedded,
}) => {
  const handleExclusiveToggle = (branchKey, currentExclusiveState) => {
    const newExclusiveState = !currentExclusiveState;
    onExclusiveChange(accountKey, examinationRoomKey, branchKey, newExclusiveState);
  };

  return (
    <ItemContainer key={accountKey}>
      <ItemWrapper isEdit>
        <ItemWrapper
          style={{
            height: '40px',
          }}
        >
          <RemoveItemIcon onClick={removeItem} />
          <ItemImage src={image} alt="dr-image" />
          <ItemDetails>
            <ItemName>{`${name}${topLevelEntityName ? ` - ${topLevelEntityName}` : ''}`}</ItemName>
            <ItemDescription>{specialtyName}</ItemDescription>
          </ItemDetails>
        </ItemWrapper>
      </ItemWrapper>
      <ItemWrapper>
        <BranchesList>
          {branches?.map(branch => (
            <Checkbox
              checked={branch.isChecked}
              key={branch.branchKey}
              handleCheckboxClick={() => {
                onChangeBranchSelection(accountKey, examinationRoomKey, branch.branchKey);
              }}
              checkboxObj={{
                key: branch.branchKey,
                name: (
                  <div
                    style={{
                      display: 'flex',
                      gap: '12px',
                    }}
                  >
                    <BranchName key={branch.branchKey}>{branch.branchName}</BranchName>
                  </div>
                ),
              }}
            />
          ))}
        </BranchesList>
      </ItemWrapper>
      <ItemWrapper>
        <BranchesList>
          {branches?.map(branch => (
            <Toggle
              key={branch.branchKey}
              isActive={isEmbedded ? branch.isSpoke || false : branch.isExclusive || false}
              onClick={() =>
                handleExclusiveToggle(
                  branch.branchKey,
                  isEmbedded ? branch.isSpoke : branch.isExclusive,
                )
              }
              isEnabled={branch.isChecked}
            />
          ))}
        </BranchesList>
      </ItemWrapper>
    </ItemContainer>
  );
};

DoctorRecord.propTypes = {
  accountKey: PropTypes.string,
  image: PropTypes.string,
  name: PropTypes.string,
  specialtyName: PropTypes.string,
  removeItem: PropTypes.func,
  branches: PropTypes.arrayOf(PropTypes.shape({})),
  examinationRoomKey: PropTypes.string,
  topLevelEntityName: PropTypes.string,
  onChangeBranchSelection: PropTypes.func,
  onExclusiveChange: PropTypes.func,
  isEmbedded: PropTypes.bool,
};

export default DoctorRecord;
